module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS8.f2f03c69.jpg";